// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3143d368","138":"b2ae6cd3","191":"76ec0fb5","217":"0b1f29c5","272":"a3e4f1d7","283":"b9b39fc7","371":"6c0984ea","414":"dddd0f96","597":"808a7401","756":"0fc73640","896":"90610a00","970":"0b8de9a9"}[chunkId] + ".chunk.js";
};